import axios from 'axios';
import { v4 as uuid } from 'uuid'
import { TUTOR_CAPITALIZE, TUTOR_VOICE } from '../../utils/const';
const API_URL = import.meta.env.VITE_APP_API_URL;

export const getToken = async ({ isCustomBot = false, instructor, userId = null, hasCourse = false, tokenData }, { signal }) => {
  const _instructor = isCustomBot ? instructor : TUTOR_CAPITALIZE[instructor];

  const requestData = {
    instructor: _instructor,
    course: _instructor,
    metadata: JSON.stringify({
      voice_id: isCustomBot ? tokenData.voiceId : TUTOR_VOICE[_instructor],
      institution: 'Quiklearn',
      courseId: _instructor,
      session_id: uuid(),
      device: 'web',
      userId: userId || "parthroy",
      vector_token: isCustomBot ? tokenData?.sessionId || "" : ""
    }),
  };

  try {
    console.log('requestData', JSON.stringify(requestData, null, 4));

    const response = await axios.post(API_URL, requestData, {
      headers: {
        'Content-Type': 'application/json',
      },
      signal
    });
    return response.data; // Handle response data as needed
  } catch (error) {
    console.error('Error fetching token:', error);
    throw error; // Rethrow error for further handling
  }
};